import { render, staticRenderFns } from "./types.vue?vue&type=template&id=3af1fcd2&scoped=true&"
import script from "./types.vue?vue&type=script&lang=js&"
export * from "./types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af1fcd2",
  null
  
)

export default component.exports